import { css } from 'styled-components'

export const Colors = css`
  :root {
    --brand-90: #00427e;
    --brand-70: #005cb1;
    --brand-50: #0083fc;
    --brand-40: #99cdfe;
    --brand-20: #cce6fe;
    --brand-10: #e5f2ff;
    --brand-5: #f2f9ff;

    --white: #ffffff;
    --black-100: #000000;
    --black-90: #1a1a1a;
    --black-80: #333333;
    --black-70: #4d4d4d;
    --black-60: #666666;
    --black-50: #808080;
    --black-40: #999999;
    --black-30: #b3b3b3;
    --black-20: #cccccc;
    --black-10: #e6e6e6;
    --black-8: #ebebeb;
    --black-6: #f0f0f0;
    --black-4: #f5f5f5;
    --black-2: #fafafa;

    --red-50: #f2373e;

    --purple-60: #6809b2;
    --purple-8: #e6c7ff;
    --purple-2: #f9f0ff;
  }
`
